<template lang="pug">
  .app__status.app__status--live
    .app__status__rings
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">

  .app__status {
    display: block;
    margin: 10px auto;
    width: 20px;
  }

  .app__status__rings {
    display: inline-block;
    height: 15px;
    margin: 0 12px;
    padding-left: 10px;
    position: relative;
    text-align: center;
    width: 15px;
  }

  .app__status__rings::before,
  .app__status__rings::after {
    border-radius: 50%;
    content: '';
    position: absolute;
  }

  .app__status__rings::before {
    height: 5px;
    left: -1px;
    top: 9px;
    width: 5px;
  }

  .app__status__rings::after {
    animation: pulse 1s ease-out infinite;
    height: 13px;
    left: -5px;
    top: 5px;
    width: 13px;
  }

  .app__status--live .app__status__rings::before {
    background-color: #2ecc71;
  }

  .app__status--live .app__status__rings::after {
    border: 1px solid #2ecc71;
  }

  @keyframes pulse {
    0% {
      opacity: 0;
      transform: scale(.1, .1);
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0;
      transform: scale(1.2, 1.2);
    }
  }
</style>
